/* =====================================================================
   Bluewud × Empire v13 — Cart page controller.
   The native <quantity-selector> web component is dead in this build (clicking
   +/- does nothing, no AJAX). This wires quantity +/-, manual input, and remove
   to /cart/change.js and updates the UI instantly — line totals, cart totals,
   and the header count (via the fetch wrapper in bluewud-cards.js) — no refresh.
   Lines are keyed by data-cartitem-key.
   ===================================================================== */
(function () {
  'use strict';

  function money(cents) {
    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN');
  }
  function esc(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }
  function setMoney(el, cents) {
    var m = money(cents);
    var t = el.textContent;
    if (/Rs\.?\s?[\d,]+/.test(t)) el.textContent = t.replace(/Rs\.?\s?[\d,]+(\.\d+)?/, m);
    else el.textContent = m;
  }

  var CART_TOTAL_SEL = '.cart-subtotal, .cart-total, .cart-final-total, .cart-title-total, ' +
    '.cart-title-total--small, .cart-title-total--large, .atc-banner--cart-subtotal';

  function updateUI(cart) {
    (cart.items || []).forEach(function (it) {
      var line = document.querySelector('.cart-item[data-cartitem-key="' + esc(it.key) + '"]');
      if (!line) return;
      var input = line.querySelector('.quantity-selector__input');
      if (input) input.value = it.quantity;
      var lt = line.querySelector('.cart-item__total');
      if (lt) setMoney(lt, it.final_line_price);
    });
    // Drop any line whose item was removed.
    document.querySelectorAll('.cart-item').forEach(function (line) {
      var key = line.getAttribute('data-cartitem-key');
      if (!(cart.items || []).some(function (it) { return it.key === key; })) line.remove();
    });
    // Cart-level totals.
    document.querySelectorAll(CART_TOTAL_SEL).forEach(function (el) { setMoney(el, cart.total_price); });
    // Empty cart -> reload to show the empty state.
    if (cart.item_count === 0) location.reload();
  }

  function change(line, key, qty) {
    if (line.__bwBusy) return;
    line.__bwBusy = true;
    line.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(updateUI)
      .catch(function () {})
      .then(function () { line.__bwBusy = false; line.removeAttribute('aria-busy'); });
  }

  // Capture phase so we always run first. An in-flight guard stops a rapid
  // second click from reading a stale quantity and over-shooting (the likely
  // cause of minus removing/not reducing). Minus floors at 1 — removal is only
  // via the explicit remove control.
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-quantity-plus]');
    var minus = e.target.closest('[data-quantity-minus]');
    var remove = e.target.closest('.cart-item__remove, .cart-item__remove-link');
    if (!plus && !minus && !remove) return;
    var line = e.target.closest('.cart-item');
    if (!line) return;
    e.preventDefault();
    if (line.__bwBusy) return;
    var key = line.getAttribute('data-cartitem-key');
    var input = line.querySelector('.quantity-selector__input');
    var q = input ? (parseInt(input.value, 10) || 1) : 1;
    var next = remove ? 0 : (plus ? q + 1 : Math.max(1, q - 1));
    if (!remove && next === q) return;             // already at the floor (qty 1)
    change(line, key, next);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('quantity-selector__input')) return;
    var line = t.closest('.cart-item');
    if (!line || line.__bwBusy) return;
    change(line, line.getAttribute('data-cartitem-key'), Math.max(0, parseInt(t.value, 10) || 0));
  });
})();
